export default "__VITE_ASSET__C_sMqG0x__"